<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="分类名称">
        <Input
          v-model="title"
          style="width:200px"
          placeholder="请输入分类名称关键字"
          clearable
          @keydown.native.prevent.enter="getList"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getList">搜索</Button>
          <Button icon="md-undo" @click="title='';getList(true)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button @click="addClassify()" type="primary">新增分类</Button>
    <Modal v-model="addClassifyModal" :title="modalText" ref="modal">
      <div class="course-type">
        <Form ref="classifyForm" :rules="ruleValidate" :model="addClassifyInfo" :label-width="80">
          <FormItem label="所属分类">
            <p>{{addClassifyInfo.parent_name||"无"}}</p>
          </FormItem>
          <FormItem label="分类名称" prop="title">
            <Input style="width:300px" type="text" v-model="addClassifyInfo.title" :maxlength="50" />
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input style="width:100px" type="text" v-model="addClassifyInfo.sort" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="addClassifyModal = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
    <div class="content">
      <TreeGrid
        :rows="list"
        :columns="columns"
        :maxLevel="2"
        :formatter="formatter"
        childrenProperty="child"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            @click="addClassify(row)"
            type="text"
            size="small"
            :style="{visibility:!row.parent_id?'visible':'hidden'}"
          >新增-</Button>
          <!-- <Button @click="toggleEnable(row)" type="text" size="small">{{row.status==0?'启用':'禁用'}}-</Button> -->
          <Button @click="editClassify(row)" type="text" size="small">编辑-</Button>
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </template>
      </TreeGrid>
    </div>
  </div>
</template>
<script>
export default {
  name: "BookCatagory",
  data() {
    return {
      addClassifyModal: false,
      modalText: "新增分类",
      expandId: "",
      ruleValidate: {
        title: [
          { required: true, message: "分类名称必须填写", trigger: "blur" }
        ],
        sort: [
          {
            required: true,
            message: "排序必须填写",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value != "") {
                callback();
              } else {
                callback(new Error("排序必须填写"));
              }
            }
          },
          {
            type: "integer",
            message: "排序格式错误",
            trigger: "blur",
            transform(value) {
              return Number(value);
            }
          }
        ]
      },
      columns: [
        {
          title: "分类名称",
          key: "title"
        },
        {
          title: "图书数量",
          key: "book_num",
          align: "center"
        },
        {
          title: "排序",
          key: "sort",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          width: 140
        }
      ],
      title: "",
      addClassifyInfo: {},
      list: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    addClassify(row) {
      let addClassifyInfo = {};
      if (row) {
        addClassifyInfo.parent_id = row.id;
        addClassifyInfo.parent_name = row.title;
      } else {
        addClassifyInfo.parent_name = "无";
      }
      addClassifyInfo.title = "";
      addClassifyInfo.sort = "";
      this.addClassifyInfo = addClassifyInfo;
      this.modalText = "新增分类";
      this.addClassifyModal = true;
    },
    editClassify(row) {
      let addClassifyInfo = {};
      this.modalText = "编辑分类";
      addClassifyInfo.id = row.id;
      addClassifyInfo.title = row.title;
      addClassifyInfo.sort = row.sort;
      addClassifyInfo.parent_id = row.parent_id;
      addClassifyInfo.parent_name = row.parent_name;
      this.addClassifyInfo = addClassifyInfo;
      this.addClassifyModal = true;
    },
    async deleteClassify(row) {
      if (row.hasOwnProperty("child") && row.child.length > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "当前分类下含有子分类，无法删除"
        });
        return;
      }
      if (row.book_num > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "当前分类已被使用，无法删除"
        });
        return;
      }
      await this.$promiseConfirm("确定要删除该分类吗？");
      await this.$http.delete("/api/book/classify/" + row.id);
      this.expandId = row.parent_id;
      this.$Message.deleteSuccess();
      this.getList();
    },
    async save() {
      this.$refs.classifyForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.modalText == "新增分类") {
          let data = {
            title: this.addClassifyInfo.title,
            sort: this.addClassifyInfo.sort
          };
          if (this.addClassifyInfo.parent_id) {
            data.parent_id = this.addClassifyInfo.parent_id;
          }
          await this.$http.post("/api/book/classify", data);
          this.expandId = this.addClassifyInfo.parent_id;
          this.getList(true);
        } else {
          await this.$http.put(
            "/api/book/classify/" + this.addClassifyInfo.id,
            {
              title: this.addClassifyInfo.title,
              sort: this.addClassifyInfo.sort
            }
          );
          this.expandId = this.addClassifyInfo.parent_id;
          this.getList();
        }
        this.addClassifyModal = false;
        this.$Message.saveSuccess();
      });
    },
    async getList(params) {
      if (params) {
        this.page = 1;
      }
      let data = await this.$http.get("/api/book/classify", {
        title: this.title
      });
      data.forEach(item => {
        if (
          (item.id == this.expandId || this.title != "") &&
          item.child &&
          item.child.length > 0
        ) {
          item._expanded = true;
        }
      });
      this.list = data;
      this.list.forEach(i => {
        if (!i.child || i.child.length === 0) {
          i._disableExpand = true;
        }
      });
    },
    formatter(row) {
      if (!row.child) {
        return;
      }
      row.child.forEach(child => {
        child.parent_name = row.title;
      });
    },
    async toggleEnable(row) {
      await this.$http.put("/api/book/classify/disable/" + row.id);
      await this.getList();
    }
  }
};
</script>